'use client';

import SuccessIcon from './SuccessIcon.js';
import CareerPathIcon from './CareerPath.js';
import HotIcon from './Hot.js';
import UrgentIcon from './Urgent.js';

var Alert = {
    SuccessIcon: SuccessIcon,
    CareerPathIcon: CareerPathIcon,
    HotIcon: HotIcon,
    UrgentIcon: UrgentIcon
};

export { Alert as default };
//# sourceMappingURL=index.js.map
